import { NavigationGuard } from 'vue-router';
import { appModule, AppState } from '@/store/modules/app';
import store from '@/store';
import { MobileBreakpoints } from '../services/mediaQueryManager';
import { RouteNames } from '@/utils/router/router.models';

export const mobileGuard: NavigationGuard = async (to, _from, next) => {
  if ((appModule.state as AppState)?.deviceMQ in MobileBreakpoints && store.getters['app/isTabletPortrait'] === false) {
    // conditional to prevent recursion
    if (to.name !== RouteNames.MobileHome) {
      next({ name: RouteNames.MobileHome, params: { lang: store.state.app.locale.split('-')[0] } });
    } else {
      next();
    }
    // without this hack, the "watch" in App.vue will never trigger, and therefore never animate to a "loaded" UI state
    await store.dispatch('app/setLoadingState', true);
    await store.dispatch('app/setLoadingState', false);
  } else {
    next();
  }
};
